import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Documents from "@/pages/Documents";
import Portal from "@/pages/Portal";
import SchedulePage from "@/pages/SchedulePage";
import TermsPage from "@/pages/TermsPage";
import ClientPortal from "@/pages/ClientPortal";
import SettlementAccept from "@/pages/SettlementAccept";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ResetPassword from "@/pages/ResetPassword";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/portal" element={<Portal />} />
            <Route path="/client" element={<ClientPortal />} />
            <Route path="/client-login" element={<ClientPortal />} />
            <Route path="/settle/:token" element={<SettlementAccept />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
